// @flow
import React, { useCallback, useEffect, useState } from 'react';
import cx from 'classnames';

import { ScreenReaderTip, Icons, announce } from 'sarsaparilla';
import { GridHeaderCell } from './Grid';

type PropTypes = {
    isAsc?: boolean,
    isDisabled?: boolean,
    isSorted?: boolean,
    name: string,
    onSortToggle: (boolean, boolean, string) => void,
};
const SortableTableColumnHeader = ({
    isAsc = false,
    isDisabled = false,
    isSorted = false,
    name,
    onSortToggle,
}: PropTypes) => {
    const [isSortedState, setIsSortedState] = useState(isSorted);
    const [isAscState, setIsAscState] = useState(isAsc);

    useEffect(() => {
        if(isSorted !== isSortedState) {
            setIsSortedState(isSorted)
        }
    }, [isSorted, isSortedState, setIsSortedState]);

    useEffect(() => {
        if(isAsc !== isAscState) {
            setIsAscState(isAsc)
        }
    }, [isAsc, isAscState, setIsAscState]);

    const handleSortToggle = useCallback(() => {
        announce(`Sorted by ${name}: ${isAscState ? 'ascending' : 'descending'}`);

        if (isSortedState) {
            setIsAscState((prevIsAsc) => !prevIsAsc);
            onSortToggle(isSortedState, !isAscState, name);
        }
        else {
            setIsSortedState(true);
            setIsAscState(true);
            onSortToggle(true, true, name);
        }
    }, [name, isAscState, isSortedState, setIsAscState, setIsSortedState, onSortToggle]);

    let sort = 'none';
    if (isSortedState) {
        sort = isAscState ? "ascending" : "descending";
    }

    return (
        <GridHeaderCell className="sortable-column-header" aria-sort={sort} role="columnheader">
            <ScreenReaderTip content="Click to sort the table by this column">
                <button onClick={handleSortToggle} disabled={isDisabled}>
                    <span className="title">
                        {name}
                    </span>
                    <div className="sort">
                        <div className={cx({
                            disabled: isSortedState && isAscState,
                            sorted: isSortedState && !isAscState,
                            enabled: !isSortedState
                        })}>
                            <Icons.IconArrowUp />
                        </div>
                        <div className={cx({
                            disabled: isSortedState && !isAscState,
                            sorted: isSortedState && isAscState,
                            enabled: !isSortedState
                        })}>
                            <Icons.IconArrowDown />
                        </div>
                    </div>
                </button>
            </ScreenReaderTip>
        </GridHeaderCell>
    );
}
export default React.memo<PropTypes>(SortableTableColumnHeader);